/**
 * Presentation rules for on-call AI Interview slots (mirrors admin-react-v2's
 * lib/callInterviews/format.ts). Every time here is India time as
 * "YYYY-MM-DDTHH:MM" straight from admin-node — never converted through the
 * browser's timezone.
 */

export const STATUS_META = {
  SCHEDULED: { label: 'Scheduled', color: 'blue' },
  DIALING: { label: 'Dialling', color: 'gold' },
  IN_CALL: { label: 'In call', color: 'purple' },
  COMPLETED: { label: 'Completed', color: 'green' },
  DROPPED: { label: 'Dropped', color: 'orange' },
  UNREACHABLE: { label: 'Unreachable', color: 'red' },
  FAILED: { label: 'Failed', color: 'red' },
  CANCELLED: { label: 'Cancelled', color: 'default' },
  NO_PHONE: { label: 'No number', color: 'red' },
}

const SUMMARY_ORDER = ['SCHEDULED', 'DIALING', 'IN_CALL', 'COMPLETED', 'DROPPED', 'UNREACHABLE', 'NO_PHONE', 'FAILED', 'CANCELLED']

export const summaryParts = (counts = {}) =>
  SUMMARY_ORDER.filter(status => (counts[status] || 0) > 0).map(status => ({ status, count: counts[status] }))

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** "2026-09-24T16:30" -> "24 Sep, 4:30 PM" */
export const formatIst = value => {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(value || '')
  if (!match) return '—'
  const [, , month, day, hh, mm] = match
  const hour = Number(hh)
  return `${Number(day)} ${MONTHS[Number(month) - 1]}, ${hour % 12 || 12}:${mm} ${hour < 12 ? 'AM' : 'PM'}`
}

/** What the admin may do to a slot — the same rules admin-node enforces. */
export const slotActions = slot => {
  const notStarted = slot.assignmentStatus === 'PENDING'
  const finishedUnsuccessfully = ['UNREACHABLE', 'FAILED', 'CANCELLED', 'NO_PHONE'].includes(slot.status)
  return {
    canEdit: notStarted && (slot.status === 'SCHEDULED' || finishedUnsuccessfully),
    canCancel: ['SCHEDULED', 'UNREACHABLE', 'FAILED', 'NO_PHONE'].includes(slot.status),
    canRequeue: notStarted && finishedUnsuccessfully,
  }
}

export const outcomeText = slot => {
  if (slot.lastError) return slot.lastError
  switch (slot.lastOutcome) {
    case 'RESCHEDULE': return 'Candidate asked for another time'
    case 'NO_ANSWER': return 'Not answered'
    case 'DIAL_ERROR': return 'Could not place the call'
    case 'NO_REPORT': return 'Call did not report back'
    case 'ADMIN_EDIT': return 'Changed by admin'
    case 'ADMIN_CANCELLED': return 'Cancelled by admin'
    case 'COMPLETED': return 'Interview finished'
    case 'DROPPED': return 'Line dropped mid-interview'
    default: return slot.rescheduleCount > 0 ? `Rescheduled ${slot.rescheduleCount}×` : ''
  }
}

/** 212 -> "3:32" */
export const formatDuration = seconds => {
  const total = Math.max(0, Math.round(Number(seconds) || 0))
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`
}
